/** Chuỗi của thông báo hết hạn mức AI (`components/shared/ThongBaoHetHanMuc.tsx`). */
export const viHanMucAi = {
  hanMucAi: {
    tieuDe: {
      hetGoi: 'Đã hết hạn mức token AI tháng này',
      hetGoiBiCat: 'Vừa hết hạn mức token AI tháng này',
      hetToChuc: 'Đã hết hạn mức AI của tổ chức',
      hetKy: 'Đã hết hạn mức sử dụng AI của kỳ này',
      vuotPhongBan: '{{ten}} đã hết hạn mức AI {{ky}}',
      vuotPhongBanCuaBan: 'Phòng ban của bạn đã hết hạn mức AI {{ky}}',
      vuotNguoi: 'Bạn đã hết hạn mức AI {{ky}}',
      khongDuNoiDung: 'Không đủ hạn mức token AI cho nội dung gửi đi',
      khongDuKetQua: 'Không đủ hạn mức token AI cho kết quả',
      khongDuBanGhi: 'Không đủ hạn mức token AI cho bản ghi này',
      chuaKiem: 'Chưa kiểm được hạn mức token AI',
    },
    ky: { ngay: 'hôm nay', tuan: 'tuần này', thang: 'tháng này' },
    daDung: 'Đã dùng {{daDung}} / {{hanMuc}} token',
    can: 'Cần {{so}} token',
    canItNhat: 'Cần ít nhất {{so}} token',
    conToChuc: 'Tổ chức còn {{so}} token tháng này',
    conPhongBan: '{{ten}} còn {{so}} token {{ky}}',
    conPhongBanCuaBan: 'Phòng ban của bạn còn {{so}} token {{ky}}',
    conNguoi: 'Bạn còn {{so}} token {{ky}}',
    tinhNang: 'Hạn mức cho tính năng {{ten}}',
    moLai: 'Mở lại lúc {{gio}} ngày {{ngay}}',
    moLaiNgan: 'Mở lại {{gio}} {{ngay}}',
    canConNgan: 'Cần {{can}} · còn {{con}} token',
    biCat: 'Lượt xử lý đã dừng giữa chừng.',
    chuaChepLoi: 'Bản ghi này chưa được chép lời.',
    chuaTomTat: 'Chưa tóm tắt được biên bản.',
    banChepConDung: 'Bản chép lời vẫn dùng được.',
    khacVanDung: 'Các chức năng khác vẫn dùng bình thường.',
    chuaGoiDuocAi: 'Tạm chưa gọi được AI, thử lại sau ít phút.',
    heThongThuLai: 'Hệ thống sẽ thử lại; nếu vẫn lỗi hãy thử lại sau ít phút.',
    lienHeNenTang: 'Liên hệ quản trị nền tảng để nâng hạn mức.',
    lienHeToChuc: 'Cần thêm thì liên hệ quản trị viên của tổ chức.',
    lienHeQuanTri: 'Liên hệ quản trị viên để được nâng hạn mức.',
    goiYNoiDungNenTang: 'Gửi ít nội dung hơn (ít trang, ít tài liệu hơn) hoặc liên hệ quản trị nền tảng để nâng hạn mức.',
    goiYNoiDungToChuc: 'Gửi ít nội dung hơn hoặc liên hệ quản trị viên của tổ chức.',
    goiYBanGhiNenTang: 'Cắt ngắn bản ghi hoặc liên hệ quản trị nền tảng để nâng hạn mức.',
    goiYBanGhiToChuc: 'Cắt ngắn bản ghi hoặc liên hệ quản trị viên của tổ chức.',
    khiCoThem: 'Khi có thêm hạn mức, hãy bấm {{nut}}.',
    boQuaTieuDe: 'Đã nạp tệp, bỏ qua bước dựng tiêu đề bằng AI',
    boQuaTieuDeMo: 'Đoạn chia có thể kém chính xác hơn; nạp lại tệp sau khi khắc phục để chia đoạn tốt hơn.',
    maLoi: 'Mã lỗi: {{ma}}',
  },
} as const;
